import {PortalApp} from './portal-app';
import {Factory} from '../../engine/http/factory/factory';
import {DtoPortalAppInterface} from "../../interface/dto/dto-portal-app.interface";

export class PortalAppFactory implements Factory<PortalApp> {
  constructor(private api: string) {}

  build(o: DtoPortalAppInterface): PortalApp {
    const app = new PortalApp(o.id, o.label, o.shortLabel, o.description, o.iconActive, o.iconInactive, o.userAccesGranted);
    app.setMode(o.appType.id);
    return app;
  }

  getApi(): string {
    return this.api;
  }
}
